export interface MovieItem {
  id: string;
  title: string;
  category: 'movie' | 'tv' | 'variety' | 'anime';
  categoryLabel: string;
  image: string;
  rating: number;
  year: number;
  description: string;
  genre: string[];
  director: string;
  actors: string[];
  region: string;
  updateInfo: string;
  isHot: boolean;
  isNew: boolean;
  featured?: boolean;
}

export const movies: MovieItem[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    category: 'movie',
    categoryLabel: '电影',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20a%20Chinese%20science%20fiction%20film%20titled%20Wandering%20Earth%203%2C%20featuring%20a%20giant%20spaceship%20near%20a%20burning%20planet%2C%20dramatic%20orange%20and%20red%20cosmic%20lighting%2C%20epic%20scale%2C%20dark%20space%20background%20with%20stars%2C%20movie%20poster%20style%20with%20Chinese%20typography%20space%2C%20cinematic%20composition&width=600&height=800&seq=movie-poster-01&orientation=portrait',
    rating: 8.5,
    year: 2026,
    description: '太阳急速老化，持续膨胀，地球面临被吞没的危机。为了生存，人类启动"流浪地球"计划，建造上万座行星发动机，驱使地球逃离太阳系，前往4.2光年外的新家园。本作延续前作故事线，讲述地球穿越未知星域时遭遇的全新挑战。人类命运悬于一线，全球联合政府与航天员们将面临前所未有的抉择。',
    genre: ['科幻', '冒险', '灾难'],
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    region: '中国大陆',
    updateInfo: 'HD高清',
    isHot: true,
    isNew: true,
    featured: true,
  },
  {
    id: 'movie-2',
    title: '满江红2',
    category: 'movie',
    categoryLabel: '电影',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%20with%20ancient%20Chinese%20palace%20courtyard%20at%20night%2C%20lanterns%20hanging%2C%20soldiers%20in%20ancient%20armor%2C%20dramatic%20red%20and%20gold%20color%20palette%2C%20misty%20atmosphere%2C%20cinematic%20lighting%2C%20movie%20poster%20composition%2C%20dark%20moody%20background&width=600&height=800&seq=movie-poster-02&orientation=portrait',
    rating: 7.9,
    year: 2026,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一个小兵与亲兵营副统领意外被卷入一场巨大的阴谋之中。宰相秦桧命两人限时找到一个凶手，而事情却远非看起来那么简单。各方势力暗流涌动，真相逐渐浮出水面。',
    genre: ['剧情', '悬疑', '历史'],
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    region: '中国大陆',
    updateInfo: 'HD高清',
    isHot: true,
    isNew: false,
    featured: true,
  },
  {
    id: 'movie-3',
    title: '封神第二部',
    category: 'movie',
    categoryLabel: '电影',
    image: 'https://readdy.ai/api/search-image?width=600&height=800&seq=movie-poster-03&orientation=portrait&query=Epic%20Chinese%20fantasy%20movie%20poster%20inspired%20by%20Fengshen%20mythology%2C%20ancient%20Chinese%20warriors%20with%20magical%20weapons%2C%20mythical%20beasts%20in%20battle%2C%20dramatic%20golden%20and%20crimson%20lighting%2C%20epic%20scale%2C%00cinematic%20composition%2C%20traditional%20Chinese%20elements%20with%20fantasy%20aesthetic',
    rating: 8.2,
    year: 2025,
    description: '商王殷寿与狐妖妲己勾结，暴虐无道，引发天谴。昆仑仙人姜子牙携"封神榜"下山，寻找天下共主以救苍生。西伯侯之子姬发逐渐发现殷寿的本来面目，反出朝歌。各方势力暗流涌动，风云变幻端倪初显，一场浩大的封神之战即将拉开序幕。',
    genre: ['奇幻', '动作', '古装'],
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适'],
    region: '中国大陆',
    updateInfo: 'HD高清',
    isHot: true,
    isNew: false,
    featured: true,
  },
  {
    id: 'movie-4',
    title: '飞驰人生3',
    category: 'movie',
    categoryLabel: '电影',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%2C%20a%20race%20car%20speeding%20on%20a%20desert%20highway%20at%20sunset%2C%20dust%20trail%20behind%2C%20warm%20golden%20hour%20lighting%2C%20dramatic%20sky%20with%20clouds%2C%20cinematic%20action%20photography%2C%20movie%20poster%20style%20with%20motion%20blur%20effect&width=600&height=800&seq=movie-poster-04&orientation=portrait',
    rating: 7.6,
    year: 2026,
    description: '曾经的赛车冠军张驰在经历人生低谷后，重返赛道。这一次他不仅要面对更强大的对手，还要处理与年轻一代车手之间的理念冲突。在友情与梦想的抉择中，张驰将用速度证明自己的价值。',
    genre: ['喜剧', '运动', '剧情'],
    director: '韩寒',
    actors: ['沈腾', '范丞丞', '尹正', '张本煜'],
    region: '中国大陆',
    updateInfo: 'HD高清',
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-5',
    title: '哪吒之魔童闹海',
    category: 'anime',
    categoryLabel: '动漫',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20featuring%20a%20young%20mythical%20boy%20with%20red%20ribbon%20and%20fire%20wheels%20flying%20above%20turbulent%20ocean%20waves%2C%20dramatic%20lightning%20and%20storm%20clouds%2C%20vibrant%20red%20and%20gold%20color%20scheme%2C%20traditional%20Chinese%20ink%20painting%20influence%2C%20epic%20fantasy%20composition&width=600&height=800&seq=movie-poster-05&orientation=portrait',
    rating: 8.8,
    year: 2025,
    description: '天劫之后，哪吒和敖丙的灵魂虽保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身。然而在重塑肉身的过程中却遇到重重困难，哪吒、敖丙的命运将走向何方？',
    genre: ['动画', '奇幻', '动作'],
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨', '陈浩'],
    region: '中国大陆',
    updateInfo: 'HD高清',
    isHot: true,
    isNew: false,
    featured: true,
  },
  {
    id: 'movie-6',
    title: '默杀',
    category: 'movie',
    categoryLabel: '电影',
    image: 'https://readdy.ai/api/search-image?query=Dark%20Chinese%20crime%20thriller%20movie%20poster%2C%20a%20shadowy%20figure%20in%20a%20rainy%20alley%20at%20night%2C%20neon%20reflections%20on%20wet%20pavement%2C%20mysterious%20atmosphere%2C%20deep%20red%20accents%2C%20noir%20cinematography%20style%2C%20suspenseful%20mood%2C%20dark%20and%20moody%20composition&width=600&height=800&seq=movie-poster-06&orientation=portrait',
    rating: 7.8,
    year: 2025,
    description: '一起校园坠楼事件，牵扯出一连串不为人知的秘密。当沉默成为暴力的一部分，当每个人都选择袖手旁观，真相能否大白于天下？警方调查过程中，越来越多的线索指向一个令人不寒而栗的真相。',
    genre: ['悬疑', '犯罪', '剧情'],
    director: '柯汶利',
    actors: ['王传君', '张钧甯', '吴镇宇', '王圣迪'],
    region: '中国大陆',
    updateInfo: 'HD高清',
    isHot: false,
    isNew: true,
  },
  {
    id: 'movie-7',
    title: '第二十条',
    category: 'movie',
    categoryLabel: '电影',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20movie%20poster%2C%20a%20courtroom%20scene%20with%20dramatic%20lighting%2C%20scales%20of%20justice%20silhouette%2C%20solemn%20atmosphere%2C%20warm%20dark%20wood%20tones%2C%20golden%20accents%2C%20cinematic%20composition%2C%20formal%20and%20dignified%20mood&width=600&height=800&seq=movie-poster-07&orientation=portrait',
    rating: 8.0,
    year: 2025,
    description: '人到中年的检察官韩明面临职业生涯和家庭危机的双重打击。在一起看似普通的正当防卫案件中，他发现了隐藏的真相。在法律与情感的天平上，他必须做出艰难的选择，捍卫正义的最后一道防线。',
    genre: ['剧情', '法律'],
    director: '张艺谋',
    actors: ['雷佳音', '马丽', '赵丽颖', '高叶'],
    region: '中国大陆',
    updateInfo: 'HD高清',
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-8',
    title: '熊出没·重启未来',
    category: 'anime',
    categoryLabel: '动漫',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20family%20movie%20poster%2C%20two%20cartoon%20bears%20and%20a%20man%20in%20a%20futuristic%20sci-fi%20city%20with%20flying%20vehicles%2C%20bright%20colorful%20neon%20lights%2C%20playful%20and%20adventurous%20tone%2C%20cyberpunk%20elements%20with%20family-friendly%20aesthetic%2C%20vibrant%20composition&width=600&height=800&seq=movie-poster-08&orientation=portrait',
    rating: 7.2,
    year: 2025,
    description: '光头强和熊大熊二意外穿越到了未来的世界。在这个高度发达的科技时代，他们发现未来正面临一场巨大的危机。三个好朋友必须携手合作，用智慧和勇气拯救未来的世界。',
    genre: ['动画', '喜剧', '科幻'],
    director: '林汇达',
    actors: ['谭笑', '张伟', '张秉君'],
    region: '中国大陆',
    updateInfo: 'HD高清',
    isHot: false,
    isNew: false,
  },
  {
    id: 'tv-1',
    title: '庆余年第二季',
    category: 'tv',
    categoryLabel: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%2C%20a%20handsome%20man%20in%20ancient%20Chinese%20robe%20holding%20a%20sword%2C%20palace%20background%20with%20dramatic%20lighting%2C%20golden%20and%20crimson%20color%20palette%2C%20epic%20historical%20fantasy%20atmosphere%2C%20cinematic%20composition%2C%20elegant%20traditional%20Chinese%20aesthetic&width=600&height=800&seq=tv-poster-01&orientation=portrait',
    rating: 8.6,
    year: 2025,
    description: '范闲率领使团回归途中，二皇子以费介、范思辙以及滕家遗孤的安危来威胁范闲，逼他向自己俯首称臣。范闲所面对的抱月楼迷局，以及接踵而至的春闱危机，都是二皇子精心给范闲布下的陷阱。京都风云再起，各方势力蠢蠢欲动。',
    genre: ['古装', '权谋', '剧情'],
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    region: '中国大陆',
    updateInfo: '更新至36集',
    isHot: true,
    isNew: true,
    featured: true,
  },
  {
    id: 'tv-2',
    title: '狂飙',
    category: 'tv',
    categoryLabel: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%2C%20two%20men%20in%20dark%20suits%20facing%20each%20other%20in%20a%20dimly%20lit%20room%2C%20intense%20standoff%20mood%2C%20smoke%20and%20shadows%2C%20gritty%20realistic%20style%2C%20dark%20atmospheric%20lighting%2C%20dramatic%20tension%2C%20Chinese%20police%20drama%20aesthetic&width=600&height=800&seq=tv-poster-02&orientation=portrait',
    rating: 9.1,
    year: 2023,
    description: '京海市一线刑警安欣在调查一起涉黑案件时，遭到黑恶势力的打击报复。在省教育整顿驻点指导组的支持下，安欣与同事们合力攻坚，最终将盘踞京海多年的强盛集团及其背后的保护伞一网打尽。横跨二十年的正邪较量，展现了中国扫黑除恶的决心。',
    genre: ['犯罪', '剧情', '刑侦'],
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    region: '中国大陆',
    updateInfo: '全39集',
    isHot: true,
    isNew: false,
  },
  {
    id: 'tv-3',
    title: '长相思',
    category: 'tv',
    categoryLabel: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20romantic%20fantasy%20TV%20drama%20poster%2C%20a%20beautiful%20woman%20in%20flowing%20ancient%20Chinese%20dress%20in%20a%20peach%20blossom%20garden%2C%20soft%20dreamy%20lighting%2C%20pink%20and%20golden%20hues%2C%20ethereal%20atmosphere%2C%20romantic%20xianxia%20aesthetic%2C%20cinematic%20soft%20focus&width=600&height=800&seq=tv-poster-03&orientation=portrait',
    rating: 7.8,
    year: 2024,
    description: '大荒内，人、神、妖混居。流落大荒的高辛王姬玖瑶历经百年颠沛流离，失去了身份和容貌，在清水镇落脚，化身玟小六。机缘巧合下，她与青丘公子涂山璟、九头妖相柳、西炎王孙玱玹等人相遇，上演了一段荡气回肠的恩怨情仇。',
    genre: ['古装', '爱情', '奇幻'],
    director: '秦榛',
    actors: ['杨紫', '张晚意', '邓为', '檀健次'],
    region: '中国大陆',
    updateInfo: '全46集',
    isHot: true,
    isNew: false,
  },
  {
    id: 'tv-4',
    title: '大奉打更人',
    category: 'tv',
    categoryLabel: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20detective%20TV%20drama%20poster%2C%20a%20young%20man%20in%20ancient%20official%20robe%20holding%20a%20mysterious%20token%20in%20a%20foggy%20ancient%20city%20at%20night%2C%20supernatural%20elements%2C%20golden%20lantern%20light%2C%20mysterious%20atmosphere%2C%20dark%20fantasy%20aesthetic%2C%20cinematic%20composition&width=600&height=800&seq=tv-poster-04&orientation=portrait',
    rating: 7.5,
    year: 2025,
    description: '现代警校毕业的许七安穿越到大奉王朝，凭借现代刑侦知识和推理能力，屡破奇案。从一个普通的小捕快做起，他依靠智慧和勇气，一步步成为大奉王朝最年轻的打更人首领，守护一方平安。',
    genre: ['古装', '悬疑', '奇幻'],
    director: '邓科',
    actors: ['王鹤棣', '田曦薇', '刘奕君', '晏紫东'],
    region: '中国大陆',
    updateInfo: '更新至28集',
    isHot: true,
    isNew: true,
  },
  {
    id: 'tv-5',
    title: '玫瑰的故事',
    category: 'tv',
    categoryLabel: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20romance%20TV%20drama%20poster%2C%20an%20elegant%20woman%20in%20a%20rose%20garden%20at%20sunset%2C%20soft%20romantic%20lighting%2C%20pink%20roses%20in%20bloom%2C%20warm%20golden%20hour%20glow%2C%20fashionable%20contemporary%20Chinese%20aesthetic%2C%20dreamy%20atmosphere%2C%20cinematic%20portrait%20style&width=600&height=800&seq=tv-poster-05&orientation=portrait',
    rating: 8.1,
    year: 2024,
    description: '出生于书香世家的黄亦玫在人生的不同阶段，遇到了四个不同的男人。她在爱情中勇敢追求自我，在事业上不断进取突破。从青涩少女到独立女性，黄亦玫用自己的方式书写了一段绚丽多彩的玫瑰人生。',
    genre: ['爱情', '都市', '剧情'],
    director: '汪俊',
    actors: ['刘亦菲', '佟大为', '林更新', '万茜'],
    region: '中国大陆',
    updateInfo: '全38集',
    isHot: false,
    isNew: false,
  },
  {
    id: 'tv-6',
    title: '小巷人家',
    category: 'tv',
    categoryLabel: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20slice%20of%20life%20TV%20drama%20poster%2C%20a%20traditional%20Chinese%20alleyway%20with%20families%20sitting%20outside%20their%20homes%2C%20warm%20nostalgic%20lighting%2C%201980s%20China%20setting%2C%20clothes%20hanging%20on%20lines%2C%20community%20life%2C%20golden%20afternoon%20light%2C%20heartwarming%20realistic%20style&width=600&height=800&seq=tv-poster-06&orientation=portrait',
    rating: 8.3,
    year: 2024,
    description: '上世纪80年代初，苏州棉纺厂家属区一条小巷里住着庄家、林家两个家庭。恢复高考、改革开放等时代变迁下，两代人的命运发生着深刻变化。温情的小巷生活中，有欢笑也有泪水，见证了中国社会的巨大变迁。',
    genre: ['剧情', '家庭', '年代'],
    director: '张开宙',
    actors: ['闫妮', '李光洁', '郭晓东', '蒋欣'],
    region: '中国大陆',
    updateInfo: '全40集',
    isHot: false,
    isNew: false,
  },
  {
    id: 'variety-1',
    title: '奔跑吧·第九季',
    category: 'variety',
    categoryLabel: '综艺',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20a%20group%20of%20celebrities%20running%20and%20laughing%20in%20a%20colorful%20outdoor%20setting%2C%20bright%20sunny%20day%2C%20energetic%20and%20fun%20atmosphere%2C%20game%20show%20elements%2C%20vibrant%20colors%2C%20playful%20composition%2C%20dynamic%20action%20pose&width=600&height=800&seq=variety-poster-01&orientation=portrait',
    rating: 7.6,
    year: 2026,
    description: '热门户外竞技真人秀节目《奔跑吧》第九季强势回归！本季将带领观众走遍全国各地的美丽风景，全新的游戏环节和任务挑战让节目更加精彩刺激。固定MC与新嘉宾的化学反应持续升温，笑料不断。',
    genre: ['真人秀', '竞技', '搞笑'],
    director: '姚译添',
    actors: ['李晨', '郑恺', '沙溢', '白鹿', '周深', '范丞丞', '张真源'],
    region: '中国大陆',
    updateInfo: '更新至2026-07-25期',
    isHot: true,
    isNew: true,
  },
  {
    id: 'variety-2',
    title: '向往的生活·第十季',
    category: 'variety',
    categoryLabel: '综艺',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20slow%20life%20variety%20show%20poster%2C%20a%20cozy%20countryside%20courtyard%20with%20wooden%20house%20and%20vegetable%20garden%2C%20warm%20sunlight%2C%20green%20mountains%20in%20background%2C%20peaceful%20rural%20China%20setting%2C%20golden%20hour%20glow%2C%20pastoral%20idyllic%20aesthetic&width=600&height=800&seq=variety-poster-02&orientation=portrait',
    rating: 8.0,
    year: 2026,
    description: '《向往的生活》第十季来到了云南大理的苍山洱海之间。黄磊、何炅携新老成员一起回归田园生活，自给自足、招待远道而来的朋友。在美丽的自然风光中，享受慢生活的惬意与温情。',
    genre: ['真人秀', '生活', '美食'],
    director: '王征宇',
    actors: ['黄磊', '何炅', '张艺兴', '彭昱畅', '张子枫'],
    region: '中国大陆',
    updateInfo: '更新至2026-07-26期',
    isHot: true,
    isNew: true,
  },
  {
    id: 'variety-3',
    title: '乘风破浪·第六季',
    category: 'variety',
    categoryLabel: '综艺',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20variety%20show%20poster%2C%20multiple%20women%20in%20stunning%20stage%20costumes%20performing%20on%20a%20glittering%20stage%2C%20spotlight%20effects%2C%20glamorous%20atmosphere%2C%20empowering%20vibe%2C%20elegant%20and%20powerful%20composition%2C%20gold%20and%20silver%20accents&width=600&height=800&seq=variety-poster-03&orientation=portrait',
    rating: 7.9,
    year: 2026,
    description: '女性音乐竞演真人秀《乘风破浪》第六季火热来袭！30位来自不同领域的姐姐们将再次集结，通过唱跳表演展现成熟女性的魅力与力量。全新赛制、全新挑战，姐姐们将在舞台上绽放最耀眼的光芒。',
    genre: ['真人秀', '音乐', '竞技'],
    director: '吴梦知',
    actors: ['宁静', '那英', '王心凌', '于文文'],
    region: '中国大陆',
    updateInfo: '更新至2026-07-27期',
    isHot: true,
    isNew: true,
  },
  {
    id: 'variety-4',
    title: '脱口秀大会·第七季',
    category: 'variety',
    categoryLabel: '综艺',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20stand-up%20comedy%20show%20poster%2C%20a%20comedian%20on%20stage%20with%20microphone%20stand%2C%20spotlight%20from%20above%2C%20dark%20audience%20background%2C%20comedic%20atmosphere%2C%20warm%20stage%20lighting%2C%20entertaining%20live%20performance%20vibe%2C%20simple%20but%20effective%20composition&width=600&height=800&seq=variety-poster-04&orientation=portrait',
    rating: 8.4,
    year: 2025,
    description: '《脱口秀大会》第七季汇集了全国最优秀的脱口秀演员，他们用幽默犀利的语言讲述生活中的趣事、社会现象和个人感悟。笑点密集，金句频出，让你在欢笑中思考人生。',
    genre: ['脱口秀', '喜剧', '谈话'],
    director: '李诞',
    actors: ['李诞', '王建国', '庞博', '呼兰', '何广智'],
    region: '中国大陆',
    updateInfo: '全10期',
    isHot: false,
    isNew: false,
  },
  {
    id: 'anime-1',
    title: '斗破苍穹·年番',
    category: 'anime',
    categoryLabel: '动漫',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20anime%20poster%2C%20a%20young%20warrior%20in%20martial%20arts%20robe%20with%20glowing%20energy%20surrounding%20him%2C%20floating%20in%20the%20air%20above%20ancient%20Chinese%20landscape%2C%20fire%20and%20light%20effects%2C%20epic%20cultivation%20fantasy%20style%2C%20dramatic%20composition%2C%20dynamic%20action%20pose&width=600&height=800&seq=anime-poster-01&orientation=portrait',
    rating: 8.3,
    year: 2025,
    description: '萧炎在迦南学院内院修行期间，实力突飞猛进。他一边提升修为一边寻找异火的下落，为三年之约做最后的准备。黑角域各方势力蠢蠢欲动，一场足以改变大陆格局的风暴正在酝酿之中。',
    genre: ['动画', '奇幻', '热血'],
    director: '赵丙乐',
    actors: ['张沛', '黑石稔', '冯骏骅', '杨梦露'],
    region: '中国大陆',
    updateInfo: '更新至68集',
    isHot: true,
    isNew: true,
  },
  {
    id: 'anime-2',
    title: '完美世界',
    category: 'anime',
    categoryLabel: '动漫',
    image: 'https://readdy.ai/api/search-image?query=Chinese%203D%20donghua%20anime%20poster%2C%20a%20young%20boy%20in%20ancient%20Chinese%20fantasy%20armor%20riding%20a%20mythical%20beast%2C%20magical%20forest%20background%20with%20glowing%20elements%2C%20epic%20fantasy%20world%2C%20golden%20and%20emerald%20color%20scheme%2C%20grand%20adventure%20aesthetic%2C%20cinematic%20lighting&width=600&height=800&seq=anime-poster-02&orientation=portrait',
    rating: 8.5,
    year: 2025,
    description: '石昊在大荒中历经磨难，不断突破自身极限。他凭借坚韧不拔的意志和超凡的天赋，一步步走向强者之路。在探索完美世界奥秘的旅途中，他将遇到前所未有的挑战和机遇。',
    genre: ['动画', '奇幻', '冒险'],
    director: '汪成果',
    actors: ['锦鲤', '刘晴', '赵乾景', '赵路'],
    region: '中国大陆',
    updateInfo: '更新至156集',
    isHot: true,
    isNew: false,
  },
  {
    id: 'anime-3',
    title: '凡人修仙传·星海飞驰篇',
    category: 'anime',
    categoryLabel: '动漫',
    image: 'https://readdy.ai/api/search-image?query=Chinese%203D%20cultivation%20donghua%20poster%2C%20a%20stoic%20man%20in%20traditional%20daoist%20robe%20flying%20on%20a%20sword%20through%20starry%20cosmic%20space%2C%20celestial%20phenomena%2C%20nebula%20and%20stars%2C%20mystical%20immortal%20cultivation%20atmosphere%2C%20dark%20blue%20and%20gold%20accents%2C%20epic%20scale&width=600&height=800&seq=anime-poster-03&orientation=portrait',
    rating: 9.0,
    year: 2025,
    description: '韩立筑基成功后踏上星海之旅，进入乱星海深处探索更广阔的修仙世界。在新的环境中，他面临更强大的敌人和更残酷的修仙法则。低调谨慎的韩立将如何在星海中开辟自己的修仙之路？',
    genre: ['动画', '仙侠', '冒险'],
    director: '伍镇焯',
    actors: ['钱文青', '杨天翔', '乔诗语', '李诗萌'],
    region: '中国大陆',
    updateInfo: '更新至52集',
    isHot: true,
    isNew: false,
  },
  {
    id: 'anime-4',
    title: '仙逆',
    category: 'anime',
    categoryLabel: '动漫',
    image: 'https://readdy.ai/api/search-image?query=Chinese%203D%20donghua%20poster%2C%20a%20determined%20young%20cultivator%20with%20flowing%20black%20hair%20surrounded%20by%20swirling%20spiritual%20energy%2C%20dark%20and%20mysterious%20ancient%20ruins%20background%2C%20purple%20and%20gold%20energy%20effects%2C%20dramatic%20lighting%2C%20revenge%20themed%20epic%20fantasy%20composition&width=600&height=800&seq=anime-poster-04&orientation=portrait',
    rating: 8.7,
    year: 2025,
    description: '平凡少年王林因意外获得修仙机缘，从此踏上逆天改命之路。他凭借惊人的毅力和智慧，在修仙世界中杀出一条血路。以凡人之躯比肩神明，用铁血手段践行"顺为凡、逆为仙"的信念。',
    genre: ['动画', '仙侠', '热血'],
    director: '石头熊',
    actors: ['史泽鲲', '常文涛', '周湘宁', '刘思岑'],
    region: '中国大陆',
    updateInfo: '更新至48集',
    isHot: false,
    isNew: true,
  },
];

export const heroFeatured = movies.filter(m => m.featured);

export const getByCategory = (category: string) => movies.filter(m => m.category === category);

export const getHotMovies = () => movies.filter(m => m.isHot);

export const getNewMovies = () => movies.filter(m => m.isNew);

export const getById = (id: string) => movies.find(m => m.id === id);

export const getRelated = (item: MovieItem, count: number = 6) => {
  return movies
    .filter(m => m.id !== item.id && m.category === item.category)
    .slice(0, count);
};